module.exports = __webpack_public_path__ + "img/bg-nosotros-1.65f4e548.png";